import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const FragmentadorasPage = lazy(() => import('../pages/fragmentadoras/page'));
const CompararModelosPage = lazy(() => import('../pages/comparar-modelos/page'));
const ProdutoPage = lazy(() => import('../pages/fragmentadoras/produto/page'));
const AluguelPage = lazy(() => import('../pages/aluguel/page'));
const AssistenciaTecnicaPage = lazy(() => import('../pages/assistencia-tecnica/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ArtigoPage = lazy(() => import('../pages/blog/artigo/page'));
const GarantiaPage = lazy(() => import('../pages/garantia/page'));
const TrocasDevolucoesPage = lazy(() => import('../pages/trocas-devolucoes/page'));
const PrivacidadePage = lazy(() => import('../pages/privacidade/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/fragmentadoras',
    element: <FragmentadorasPage />
  },
  {
    path: '/fragmentadoras/:id',
    element: <ProdutoPage />
  },
  {
    path: '/comparar-modelos',
    element: <CompararModelosPage />
  },
  {
    path: '/aluguel',
    element: <AluguelPage />
  },
  {
    path: '/assistencia-tecnica',
    element: <AssistenciaTecnicaPage />
  },
  {
    path: '/sobre',
    element: <SobrePage />
  },
  {
    path: '/contato',
    element: <ContatoPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/:id',
    element: <ArtigoPage />
  },
  {
    path: '/garantia',
    element: <GarantiaPage />
  },
  {
    path: '/trocas-devolucoes',
    element: <TrocasDevolucoesPage />
  },
  {
    path: '/privacidade',
    element: <PrivacidadePage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
